import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { useToFill } from './shared/useToFill'
import { yesterdayStr } from '../utils/timeUtils'

export function useDlyOneYearData(ghId, year, tsId = 'DLY_TEMPAVG') {
  const begin_date = `${year}-01-01T00:00:00Z`
  // Horní mez roku, ale nikdy dál než včerejšek (dnešní/budoucí denní data se nestahují).
  const yEnd = `${year}-12-31`
  const y = yesterdayStr()
  const end_date = `${yEnd < y ? yEnd : y}T23:59:59Z`

  const queryKey = ['dlyOneYearData', tsId, ghId, year]

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: () => api.get(
      `/daily_ts?ts_id=${tsId}&gh_id=${ghId}&begin_date=${begin_date}&end_date=${end_date}`
    ).then(r => ({ result: r.data ?? [], toFill: r.to_fill ?? [] })),
    enabled: !!ghId,
    staleTime: 5 * 60 * 1000,
  })

  useToFill(queryKey, data, (_result, resp) => resp.data)

  // dataMap: "MM-DD" → value (nebo null)
  const dataMap = new Map()
  ;(data?.result ?? []).forEach(row => {
    if (row.dt == null) return
    const dt = new Date(row.dt)
    const key = `${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`
    dataMap.set(key, row.value ?? null)
  })

  return { dataMap, isLoading, isError, error }
}
